import './App.css';
import Home from './Home/Home';

import { BrowserRouter } from 'react-router-dom';
import Skills from './Skills/Skills';
import Header from './Header/Header';
import About from './About/About';
import Projects from './Projects/Projects';
import Github from './Github Stats/Github';
import Codechef from './Codechef/Codechef';
import Footer from './Footer/Footer';
import Contact from './Contact/Contact';

function App() {

  let scrollPercentage=()=>{
    let progresselem=document.getElementById("progress")
    let progressvalelem=document.getElementById("progress_value")

    let scrollval=document.documentElement.scrollTop;

    let totalHeight=document.documentElement.scrollHeight-document.documentElement.clientHeight;

    let posval=Math.round((scrollval*100)/totalHeight);

    progresselem.style.background=`conic-gradient(#008fff ${posval}%, #c0c0ff ${posval}%)`
    progressvalelem.textContent=`${posval}%`
  }
  window.onscroll=scrollPercentage;
  window.onload=scrollPercentage

  return (
    <>
      <BrowserRouter >
        <div id="progress">
          <span id="progress_value">0%</span>
        </div>
        <Header />
        <Home />
        <About />
        <Skills />
        <Github />
        <Projects />
        {/* <Codechef/> */}
        <Contact />
        <Footer />


      </BrowserRouter>

    </>



  );
}

export default App;
